<div class="d-flex flex-column align-items-center my-5 pb-5">
  <h2 class="fs-1 fw-bold mb-5">سوالات متداول</h2>
  <div></div>
  <div class="container d-flex flex-column pt-5">
    <div *ngIf="!config?.questions" class="mb-5">
      <div
        class="bg-white py-4 pe-md-5 ps-md-4 ps-2 pe-3 d-flex justify-content-between align-items-center question-container"
        data-bs-toggle="collapse"
        href="#qadefault"
        role="button"
        aria-expanded="false"
        aria-controls="qadefault"
      >
        <h5 class="fs-5 mb-0">
          چه تفاوتی بین پرینت تمام‌ رنگی و پرینت نیمه ‌رنگی وجود دارد؟
        </h5>
        <mat-icon svgIcon="chevron-up" class="blue"></mat-icon>
      </div>
      <div class="collapse" id="qadefault">
        <div class="card card-body text-justify px-5">
          <p>
            پرینت نیمه ‌رنگی برای صفحاتی است که کمتر از 50 درصد آن را تصاویر
            رنگی تشکیل می‌دهد و پرینت تمام‌ رنگی برای صفحاتی است که بیشتر از 50
            درصد آن را تصاویر رنگی تشکیل می‌دهد. در حالت کلی
            <a href="/price-list/full-color-print-price">هزینه پرینت رنگی</a> در
            زیراکسی بسیار پایین‌تر از نرخ اتحادیه است؛ ولی با انتخاب پرینت نیمه
            ‌رنگی، بیشتر از تمام ‌رنگی می‌توانید در هزینه‌های خود صرفه‌جویی
            کنید. برای دیدن تعرفه‌های نیمه ‌رنگی بر روی
            <a href="/price-list/half-color-print-price">قیمت پرینت رنگی</a>
            کلیک کنید و اگر تمایل دارید پرینت سیاه ‌و سفید داشته باشید، بر روی
            <a href="/price-list/black-and-white-print-price"
              >قیمت پرینت سیاه ‌و سفید</a
            >
            کلیک کنید.
          </p>
        </div>
      </div>
    </div>
    <ng-container *ngIf="config?.questions">
      <div class="mb-5" *ngFor="let item of config.questions">
        <a
          class="bg-white py-4 pe-md-5 ps-md-4 ps-2 pe-3 d-flex justify-content-between align-items-center question-container"
          data-bs-toggle="collapse"
          [href]="'#qa' + item.id"
          role="button"
          aria-expanded="false"
        >
          <h5 class="fs-5 mb-0" [innerHTML]="item.question"></h5>
          <mat-icon svgIcon="chevron-up" class="blue"></mat-icon>
        </a>
        <div class="collapse" [id]="'qa' + item.id">
          <div class="card card-body text-justify px-5">
            <p [innerHTML]="item.answer"></p>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
